import { put, takeLatest, select, call } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';
import { dataUriToBlob } from '../../../utils/string';

const getCurrentCenterId = state => state.identity.centerId;

function * getGalleryInformation (payload) {
  try {
    let currentCenterId;
    const { centerId } = payload;
    currentCenterId = centerId === undefined ? yield select(getCurrentCenterId) : centerId;
    const metricsResponse = yield ktRequest.get(`gallery/center/${currentCenterId}/metrics`, 'gallery');
    const pendingPhotosResponse = yield ktRequest.get(`gallery/center/${currentCenterId}/pending`, 'gallery');

    const { data: metricsData } = metricsResponse;
    const { data: pendingPhotosData } = pendingPhotosResponse;

    yield put(actions.getCenterGalleryInformationSuccess(metricsData, pendingPhotosData));
  } catch (error) {
    yield put(actions.getCenterGalleryInformationFailure(error));
  }
}

function * approvePhotos (payload) {
  try {
    const { photoIds } = payload;
    const centerId = yield select(getCurrentCenterId);
    const body = {
      photoIds,
      action: 'approve'
    };

    yield ktRequest.post(`gallery/center/${centerId}/pending`, body, 'gallery');
    yield call(getGalleryInformation, { centerId });
    yield put(actions.approvePhotosSuccess(photoIds));
  } catch (error) {
    yield put(actions.approvePhotosFailure());
  }
}

function * rejectPhotos (payload) {
  try {
    const { photoIds } = payload;
    const centerId = yield select(getCurrentCenterId);
    const body = {
      photoIds,
      action: 'reject'
    };

    yield ktRequest.post(`gallery/center/${centerId}/pending`, body, 'gallery');

    yield put(actions.rejectPhotosSuccess(photoIds));
  } catch (error) {
    yield put(actions.rejectPhotosFailure());
  }
}

function * downloadPhotos (payload) {
  try {
    const { keys, filename } = payload;

    let index = 0;
    for (const key of keys) {
      try {
        const { image, fileType } = yield ktRequest.get(`photo/${key}/download`, 'gallery');
        const blob = dataUriToBlob(image);

        let a = document.createElement('a');
        a.download = `${filename}_${index}.${fileType}`;
        a.href = URL.createObjectURL(blob);
        a.click();
        a.remove();
      } catch (error) {
        console.log(error);
      }

      index += 1;
    }

    yield put(actions.downloadPhotosSuccess());
  } catch (error) {
    yield put(actions.dowloadPhotosFailure());
  }
}

export const gallerySagas = [
  takeLatest(types.GET_CENTER_GALLERY_INFORMATION_REQUEST, getGalleryInformation),
  takeLatest(types.APPROVE_PENDING_PHOTO_REQUEST, approvePhotos),
  takeLatest(types.REJECT_PENDING_PHOTO_REQUEST, rejectPhotos),
  takeLatest(types.DOWNLOAD_PHOTOS_REQUEST, downloadPhotos)
];
